import { useState } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import SearchInput from "../components/SearchInput";
import FilterSelect from "../components/FilterSelect";
import PostsTable from "../components/PostsTable";
import useDebounce from "../hooks/useDebounce";
import useCategories from "../hooks/useCategories";
import usePosts from "../hooks/usePosts";

export default function PostsPage() {

  const [search, setSearch] =
    useState("");

  const [category, setCategory] =
    useState("");

  const [status, setStatus] =
    useState("");

  const debouncedSearch = useDebounce(search, 500);
  const {posts, loading, error, deletingId, deletePost } = usePosts(debouncedSearch,category,status,);
  const {categories} = useCategories();





  // loading state
  if (loading) {

  return (
    <div className="space-y-4">
      <div className="h-12 rounded-xl animate-pulse bg-gray-200 dark:bg-white/5" />
      <div className="h-96 rounded-2xl animate-pulse bg-gray-200 dark:bg-white/5" />
    </div>
  );
  }

  // Error state
  if (error) {

    return (
      <div>
        Failed to load posts
      </div>
    );
  }

  return (
    
    <div className="space-y-8">
      
      

      <PageHeader
        title="Posts"
        subtitle="Content Management"
        actionButton={
          <Link
            to="/admin/posts/create"
            className="
              px-6
              py-3
              rounded-xl
              bg-blue-800
              text-white
              font-medium
            "
          >
            Create Post
          </Link>
        }
      />

      <div
        className="
          grid
          md:grid-cols-3
          gap-4
        "
      >
        <SearchInput
          value={search}
          onChange={(setSearch)}
          placeholder="Search posts..."
        />

        <FilterSelect
          value={category}
          onChange={(e) =>
            setCategory(e.target.value)
          }
          options={[
            {
              value: "",
              label: "All Categories",
            },

            ...categories.map(category => ({
              value: category.slug,
              label: category.name,
            })),
          ]}
        />

        <FilterSelect
          value={status}
          onChange={(e) =>
            setStatus(e.target.value)
          }
          options={[
            {
              value: "",
              label: "All Status",
            },
            {
              value: "published",
              label: "Published",
            },
            {
              value: "draft",
              label: "Draft",
            },
            {
              value: "archived",
              label: "Archived",
            },
          ]}
        />
      </div>

      <PostsTable
        posts={posts || []} 
        deletingId={deletingId} 
        onDelete={deletePost} 
        />

    </div>
  );
}